import baseUrl from "lib/site/baseUrl";
import isIntegratedBranch from "lib/site/isIntegratedBranch";

const branchIsIntegrated = isIntegratedBranch();

/*
Determines whether to return URLs that are relative to the local or random preview domain
OR
whether to return URLs that point back to the platform domain because it is using a known deployment
*/
export default function determineUrl(urlType, platformUrl) {
  switch (urlType) {
    case "login":
      return branchIsIntegrated
        ? `${platformUrl}/login`
        : `${baseUrl("/login")}`;

    case "graphql":
      return branchIsIntegrated
        ? `${platformUrl}/graphql`
        : `${baseUrl("/api/graphql-proxy")}`;

    default:
      throw new Error(`No strategy for determining URL type of ${urlType}`);
  }
}
